import { Directive } from '@angular/core';
import { IFilteringExpressionsTree, ISortingExpression } from '@infragistics/igniteui-angular';
import { Observable } from 'rxjs';

import { ApiResponseModel } from '../../models/core/api-response.model';
import { SearchRequestModel } from '../../models/core/search-request.model';
import { DictionaryType } from '../../models/types/dictionary.type';
import { BaseListResource } from './base-list.resource';
import { BaseModel } from './base.model';

/**
 * Resource base class for searches.
 */
@Directive()
export abstract class BaseSearchResource<T extends BaseModel> extends BaseListResource {
    /**
     * Searches the records.
     * @param [description] Text to filter.
     * @param [page] Page to be returned.
     * @param [pageSize] Page's size.
     * @param filters Filters.
     * @param sortings Sortings.
     * @param extraProperties Additional properties to be added to the body.
     */
    search(
        description?: string,
        page?: number,
        pageSize?: number,
        filters?: IFilteringExpressionsTree,
        sortings?: ISortingExpression[],
        extraProperties?: DictionaryType<any>
    ): Observable<ApiResponseModel<T[]>> {
        const request = new SearchRequestModel({
            searchString: description,
            page,
            pageSize,
            filters,
            sortings
        });

        if (!!extraProperties) {
            for (const key of Object.keys(extraProperties)) {
                (request as any)[key] = extraProperties[key];
            }
        }

        return this._requestService.makePost<ApiResponseModel<T[]>>(
            this.getUrl(this._config.actions.search),
            request,
            undefined,
            this._isAbsoluteUrl,
            undefined,
            true
        );
    }
}
